import http from './base'
export default {
    addProdComm:function name(params) {
        return http({
            method: "POST",
            url: '/prodComm',
            data: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    getProdComm: function name(params){
        return http({
            method: "get",
            params: params,
            url: `/prodComm/prodComm`,
        })
    },
    getArea: function name(params) {
        return http({
            method: "get",
            params: params,
            url: `/p/area`,
        })
    },
    listForTag: function name(params) {
        return http({
            method: "get",
            url: '/prod/prodListByTagId',
            params: params
        })
    },
    list: function name(shopId) { //産品列表
        return http({
            method: "get",
            url: `/prod/list/${shopId}`,
        })
    },
    comboList: function name(params) { //套餐列表
        return http({
            method: "get",
            params: params,
            url: `/prod/combo/page`,
        })
    },
    goodsInfo: function name(shopId) { //商品详情
        return http({
            method: "get",
            url: `/prod/prodInfo/${shopId}`
        })
    },
    record: function name(param) { //商品详情
        return http({
            method: "POST",
            url: `/orderTem/record`,
            data: param,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    tagProdInfo: function name(params) { //商品详情--商品列表
        return http({
            method: "get",
            url: '/prod/tag/prodInfo',
            params: params
        })
    },
    comboInfo: function name(id) { //套餐详情
        return http({
            method: "get",
            url: `/prod/combo/info/${id}`,
        })
    },
    getAddress: function name(uuid) {
        return http({
            method: "get",
            url: `/api/eleven/${uuid}`,
        })
    },
    getFamilAddress: function name(uuid) {
        return http({
            method: "get",
            url: `/api/famil/${uuid}`,
        })
    },
    orderConfirm: function name(params) {
        return http({
            method: "POST",
            url: '/orderTem/save',
            data: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    orderConfirmCart: function name(params) {
        return http({
            method: "POST",
            url: '/orderTem/saveCart',
            data: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    categoryInfo: function name(params) { //産品分類信息列表
        return http({
            method: "get",
            params: params,
            url: `/category/categoryInfo`,
        })
    },
    tagProdTagList: function name(params) { //商品分组标签列表
        return http({
            method: "get",
            params: params,
            url: `/prod/tag/prodTagList`,
        })
    },
    tagList: function name(params) { //根据商品分组标签列表的id，获取商品列表
        return http({
            method: "get",
            params: params,
            url: `/prod/tag/list`,
        })
    },
    pageProd: function name(params) { //根据産品分類id，获取商品列表
        return http({
            method: "get",
            params: params,
            url: `/prod/pageProd`,
        })
    },
    getidlist:function name(params){
        return http({
            method: "get",
            params: params,
            url: `/prod/tag/tagList`,
        })
    },
    lastedProdPage: function name(params) { //获取每日瘋搶商品列表
        return http({
            method: "get",
            params: params,
            url: `/prod/lastedProdPage`,
        })
    },
    moreBuyProdList: function name(params) { //获取新品推薦商品列表
        return http({
            method: "get",
            params: params,
            url: `/prod/moreBuyProdList`,
        })
    },
    searchProdPage: function name(params) { //根据产品名字搜索商品列表
        return http({
            method: "get",
            params: params,
            url: `/search/searchProdPage`,
        })
    },
    listByPid: function name(params) { //获取省市区信息
        return http({
            method: "get",
            params: params,
            url: `/p/area/listByPid`,
        })
    },
    topNoticeList: function name(params) { //获取公告信息
        return http({
            method: "get",
            params: params,
            url: `/shop/notice/topNoticeList`,
        })
    },
    topSiteList: function name(params) { //获取站点信息
        return http({
            method: "get",
            params: params,
            url: `/shop/site/info`,
        })
    },
    liteIP: function name(params) {
        return http({
            method: "POST",
            url: '/liteIP',
            data: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    liteIP: function name(params) {
        return http({
            method: "POST",
            url: '/liteIP',
            data: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    regionList: function name(id) { 
        return http({
            method: "POST",
            url: `/info/region`,
            params: {
                shopId:id
            },
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    createOrder: function name(orderNumber) { 
        return http({
            method: "GET",
            url: `/payPal/createOrder`,
            params: {
                orderNumber:orderNumber
            },
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    orderTem: function name(orderNumber) { 
        return http({
            method: "GET",
            url: `/orderTem/info`,
            params: {
                orderNumber:orderNumber
            },
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    getPostCode: function name(id) { 
        return http({
            method: "GET",
            url: `/p/area/areaInfo`,
            params: {
                areaId:id
            },
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    getVcode: function name(params) { 
        return http({
            method: "POST",
            url: `/orderTem/sendSms`,
            params: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    Vercode: function name(params) { 
        return http({
            method: "POST",
            url: `/orderTem/ver`,
            params: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    faceBook: function name(params) {
        return http({
            method: "get",
            params: {
                shopId: params
            },
            url: `/info`,
        })
    },
    indexImgs: function name(params) {
        return http({
            method: "GET",
            url: `/indexImgs`,
            params: params,
            
        })
    },
    newInfo: function name(params) { //商品详情
        return http({
            method: "get",
            url: `/prod/prodInfo/${params.uuid}/${params.prodId}`
        })
    },
    getOrderNumber: function name(params) { //通过手机号查询订单编号
        return http({
            method: "POST",
            url: `/delivery/getOrderNumber`,
            params: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
    getGoodInfo: function name(params) { //查询全部货态明细
        return http({
            method: "POST",
            url: `/delivery/getInfo`,
            params: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/goods.js